import script from "./ProfileUserComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileUserComponent.vue?vue&type=script&setup=true&lang=js"

import "./ProfileUserComponent.vue?vue&type=style&index=0&id=93445ba0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93445ba0"]])

export default __exports__